import React, { useEffect, useRef, useState } from "react";
import styles from "./userDropdown.module.scss";
import { chatwindowDetails, contacts, initialStateModel, LoginState, recentChatSocketReducerStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { getcontactDetail, SearchFilter } from "../../../../base/utils";
import store from "../../../../context/store/store";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import { clearArchiveMessage } from "../../../../base/socketChatService/newChat";
import { SocketChatService } from "../../../../base/socketChatService";
import { generateChatID, userInfo } from "../../../../base/socketChatService/utils";
import { Types } from "../../../../context/action/action";
import _ from "lodash";
import { URButton } from "../../../../shared/widgets/button";
import { useHistory } from "react-router-dom";
import closeIcn from "../../../../styles/images/closeicon.svg";
import teamIcn from "../../../../styles/images/teamimg.svg";
import singleIcon from "../../../../styles/images/Welaunch_Profile_Pic.svg";
type creategroupState = {
  contactList: Array<any>;
  searchContactList: Array<any>;
  favourtieList: Array<any>;
  addmember: Array<any>;
  memberList: [];
  search:string;
};
export default function ChatNewdrpdown() {
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const {recentChatList}: recentChatSocketReducerStateModel = 
  useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const loginDetails: any = useSelector((state: initialStateModel) => state.loginReducer);
  const recentArray = Object.values(recentChatList);
  const socketService = useRef<any>(null);
  //console.log(recentArray,"recentArray")
  const history = useHistory();
  const workContacts: any = contactList.allContacs;
  let favourtie: any = workContacts.filter((contact: any) => { return contact.is_favourite === 1 })
  const [teamDetails, setDetails] = useState<creategroupState>({
    addmember: [],
    favourtieList:favourtie,
    contactList: workContacts,
    searchContactList: workContacts,
    memberList: [],search:""
  });
  let { newUserMembers, isMultiNewUserchat, isNewMessageWindow, isChatWindow, multiMemberList,chatWindowDetails } = chatWindow;
  let multiArray: any = [];
  const [dropdown, setDropdown] = React.useState(true);
  if (isMultiNewUserchat && newUserMembers && Array.isArray(newUserMembers)) {
    // MultiUserNames

    newUserMembers.map((contact: any) => multiArray.push(contact.caller_id));
  }

  newUserMembers = newUserMembers || [];
  const onChangeaddMembers = (value: any) => {
    // debugger;
    if(value.length===0){
      store.dispatch({
        type: Types.DROPDOWN_NEWCHAT,
        payload: {
          dropdownNewChat: false
        }
      });
    }else {
      store.dispatch({
        type: Types.DROPDOWN_NEWCHAT,
        payload: {
          dropdownNewChat: true
        }
      });
    }
    let { userdetails }: LoginState = store.getState().loginReducer;

    let contact: any = value.map((item: string) => {
      return getcontactDetail(item?.toString(), workContacts, userdetails);
    });
    contact = contact || [];

    if (value.length > 1 && value[value.length - 1].toString().includes("con")) {
      toastInformation("You can't select team and individual same time", "failure");
      return;
    }
    if (contact[0]?.team_id && value?.length > 1) {
      toastInformation("You can't select team and individual same time", "failure");
      return;
    }

    /* ChatBottom Display Name NewChat */
    if (!_.isUndefined(multiMemberList)) {
      contact.map((nameList: any) => {
        multiMemberList.push(nameList.caller_id);
      });
    }

    const chatService = new SocketChatService(userInfo().fromID, userInfo().toID);
    setDetails({ ...teamDetails, addmember: value, memberList: contact, searchContactList: workContacts });

    if (contact[0]) {
      let chatId: any = contact[0]?.sip_login_id
        ? generateChatID(userInfo().fromID, contact[0]?.sip_login_id.toString())
        : contact[0]?.team_id.toString();
      contact[0].chatId = chatId;
    }

    chatService.updateTeamMembers(contact);
    if (value.length === 1) {
      chatService.fetchChatHistory(contact[0]);
    } else {
      clearArchiveMessage();
    }
    setDropdown(false);
    value.length === 0 &&
      store.dispatch({
        type: Types.OPEN_CHAT_WINDOW,
        payload: {
          isChatWindow: isChatWindow,
          chatWindowDetails: {},
          isMySpace: false,
          isNewMessageWindow: isNewMessageWindow,
          newUserMembers: [],
          multiMemberList: []
        }
      });
  };

  const onSearchMembers = (value: any) => {
    let response = SearchFilter(teamDetails?.contactList, value.toLowerCase());
    setDetails({ ...teamDetails, searchContactList: response,search:value });
    response.length>0?setDropdown(true):setDropdown(true);
  };

  let len = teamDetails?.searchContactList?.length >7? Math.ceil(teamDetails?.searchContactList?.length / 8):1;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  useEffect(() => {
    var input: any = document.getElementById("my-input");
    if (input !== null) {
      input.focus();
    }
  }, []);  

  function onFocus() {
    setDropdown(true);
  }
   

    const cancelWindow = () =>{
      const userDetailsnew = userInfo();
      store.dispatch({
        type: Types.DROPDOWN_NEWCHAT,
        payload: {
          dropdownNewChat: true
        }
      });
      const currUser = parseInt(userDetailsnew.fromID);
      let sipid = loginDetails?.userdetails?.sip_login_id;
      const userDetails = loginDetails.userdetails;
      const socketservice = new SocketChatService(userDetails?.sip_login_id, userDetails?.domain_id);
     // if(sipid){
      var result:any = _.chain(recentArray).sortBy((item:any) => {
        if(item?.lastmessage?.timestamp ||  item?.timestamp){
          return item?.lastmessage?.timestamp ? item?.lastmessage?.timestamp :item?.timestamp
        } else {
          return -1
        }
      }, ['desc']).filter((value:any)=>{
        return value?.settings?.isPinned?.["s"+sipid]===0 && 
        value?.settings?.isArchive?.["s"+sipid]===0 && 
        value?.settings?.isDeleted?.["s"+sipid]===0
      }).reverse().flatten()
      .value();
      if(Array.isArray(result) && result.length>0){
        if(result[0].type===1 && chatWindowDetails ){
            const toUser = contactList.workContactsnew?.[result[0]?.users?.["s"+currUser]];
            let chatDetail ={chatId:generateChatID(userInfo().fromID, chatWindowDetails?.sip_login_id ? chatWindowDetails?.sip_login_id :toUser?.sip_login_id )};
            if(socketservice ){
              socketservice?.openChatWindow(chatWindowDetails?.sip_login_id ? chatWindowDetails:contactList.workContactsnew?.[result[0]?.users["s"+currUser]],history,chatDetail)
            
          }
        }else if(result[0].type===2 && chatWindowDetails ) {
         
            if(socketservice ){
              socketservice?.openChatWindow(chatWindowDetails?.team_id ? chatWindowDetails: contactList.teamContacsnew?.["con"+result[0]?.chatId],history)
          }
        }
      }
  
     }

  return (
    <>
      <div className={styles.newChatdropdown}>
        <div className={styles.newMsgTitle}>
          <h4 onClick={cancelWindow}><img className={styles.iconcloses} src={closeIcn} alt="team icon" /> {isMultiNewUserchat ? multiArray?.join() : "New Message"}</h4>
          {/* <URButton className="urButton buttonWhite" name="Cancel" onClick={cancelWindow}/>  */}
        </div>

        {!isMultiNewUserchat ? (
          <div className={styles.boxSec}>
            {/* <span className={styles.toText}>To:</span> */}
            <div className={styles.dropdwnSec}>
              <div className={styles.drpDownSS}>
                <Select
                 onDropdownVisibleChange={onFocus}
                autoFocus={true}
                   id="my-input"
                   mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Enter name / extension "
                  className="createNewSel newChatDrpdwn"
                  defaultOpen={true}
                  dropdownClassName="newChatSel drpdwnOverlay"
                  value={teamDetails.addmember}
                  showSearch={true}
                  onChange={(e: any) => onChangeaddMembers(e)}
                  onSearch={onSearchMembers}
                  filterOption={false}
                  open={dropdown}
                >
          {teamDetails?.search === "" && teamDetails?.favourtieList?.length >0 && <div className="titlesdrop" key={200}>Favourite / Frequently Contacted</div>}
          {teamDetails?.search === "" && teamDetails?.favourtieList?.map((contact: any, index: number) => {
        

            return (
              <option value={contact?.sip_login_id} key={index}>
                <div className="dropdowndesign">
                  <div className="usergroupss">
                    <URAvatarGroup className={`lefts size20 colorBG${random_color[index]} ${(contact?.profile_image_thumbnail!== null && contact?.profile_image_thumbnail !== "")?'avatarWithImg':'' }`}  profileInfo={
                      <>
                        { contact?.is_blocked === 1 ? <img src={singleIcon} alt="" />:
                        (contact.ImageURL !== null && contact.ImageURL !== "") &&
             (contact.profile_image_url !== null && contact.profile_image_url !== "") ? (
              <img src={contact.ImageURL ? contact.ImageURL : contact.profile_image_url} alt="" />
                            ) : (
                              contact?.team_id ? <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>:
                              <span>{contact?.first_name.charAt(0) + contact?.last_name.charAt(0)}</span> 
                            )}

                        <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                      </>
                    } />
                  </div>
                  <div className="names">{contact?.team_name ? contact?.team_name : contact?.caller_id}</div>
                  <div className="ext">{contact?.ext && contact?.ext}</div>
                </div>
              </option>
            );

          })}
                 {teamDetails?.searchContactList?.length>0 && <div className="titlesdrop">Contact</div>}
                  {teamDetails?.searchContactList.map((contact: any, indexes: number) => {
                    return (
                      <option value={contact.team_id ? `con${contact.team_id}` : contact.sip_login_id} key={100+indexes}>
                        <div className="dropdowndesign">
                          <div className="usergroupss">
                            <URAvatarGroup
                              className={`lefts size20 colorBG${random_color[indexes]} ${((contact.ImageURL !== null && contact.ImageURL !== "") &&
                              (contact.profile_image_url !== null && contact.profile_image_url !== ""))?'avatarWithImg':'' }`}
                              profileInfo={
                                <>
                                 {contact?.is_blocked === 1 ? <img src={singleIcon} alt="" />:
                                 (contact.ImageURL !== null && contact.ImageURL !== "") &&
                            (contact.profile_image_url !== null && contact.profile_image_url !== "") ? (
                            <img src={contact.ImageURL ? contact.ImageURL : contact.profile_image_url} alt="" />
                            ) : (
                                        contact.team_id ?
                                        <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>:
                                        <span>{contact?.first_name.charAt(0) + contact?.last_name.charAt(0)}</span> 
                                      )}

                                  {contact?.caller_id &&<URStatusDot className={userStatusColor(contact?.user_status, "small")} />}
                                </>
                              }
                            />
                          </div>
                          <div className="names">{contact.team_name ? contact.team_name : contact.caller_id}</div>
                          <div className="ext">{contact.ext && contact.ext}</div>
                        </div>
                      </option>
                    );
                  })}
                </Select>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
